// =========================================================
// * Volt React Dashboard
// =========================================================

// * Product Page: https://themesberg.com/product/dashboard/volt-react
// * Copyright 2021 Themesberg (https://www.themesberg.com)
// * Official Repository: https://github.com/themesberg/volt-react-dashboard
// * License: MIT License (https://themesberg.com/licensing)

// * Designed and coded by https://themesberg.com

// =========================================================

// * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software. Please contact us to request a removal.
//dedut 
// import React from 'react';
// import ReactDOM from 'react-dom';
// import { HashRouter } from "react-router-dom";

// // core styles
// import "./scss/volt.scss";

// // vendor styles
// import "react-datetime/css/react-datetime.css";

// import HomePage from "./pages/HomePage";
// import ScrollToTop from "./components/ScrollToTop";

// ReactDOM.render(
//   <HashRouter>
//     <ScrollToTop />
//     <HomePage />
//   </HashRouter>,
//   document.getElementById("root")
// );


// import React from 'react';
// import ReactDOM from 'react-dom';
// import { HashRouter } from "react-router-dom";

// // ✅ Import du AuthProvider
// import { AuthProvider } from "./AuthContext"; // ← assure-toi que le chemin est correct

// // core styles
// import "./scss/volt.scss";

// // vendor styles
// import "react-datetime/css/react-datetime.css";

// import HomePage from "./pages/HomePage";
// import ScrollToTop from "./components/ScrollToTop";

// ReactDOM.render(
//   <HashRouter>
//     <AuthProvider> {/* ✅ AuthContext autour de l'app */}
//       <ScrollToTop />
//       <HomePage />
//     </AuthProvider>
//   </HashRouter>,
//   document.getElementById("root")
// );

import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from "react-router-dom"; // ✅ Utiliser BrowserRouter

// ✅ Import du AuthProvider
import { AuthProvider } from "./AuthContext"; // ← assure-toi que le chemin est correct

// core styles
import "./scss/volt.scss";

// vendor styles
import "react-datetime/css/react-datetime.css";

import HomePage from "./pages/HomePage";
import ScrollToTop from "./components/ScrollToTop";

ReactDOM.render(
  <BrowserRouter> {/* ✅ Utilisation de BrowserRouter ici */}
    <AuthProvider>
      <ScrollToTop />
      <HomePage />
    </AuthProvider>
  </BrowserRouter>,
  document.getElementById("root")
);
